import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { formatDateAt } from "simplydo/core/dates";
import { ideaCoverImage } from "simplydo/core/images";

import { UserChip } from "components/lib/Chips";
import FormattedComment from "components/lib/FormattedComment";

import { FeedItemOfType } from "../types";
import {
  FeedItem,
  FeedItemContent,
  FeedItemDate,
  FeedItemIcon,
  FeedItemMessage,
} from "./FeedItemUI";

type IdeaCommentFeedItemProps = { item: FeedItemOfType<"ideaComment"> };

const IdeaCommentFeedItem = ({ item }: IdeaCommentFeedItemProps) => {
  const { t } = useTranslation();

  return (
    <FeedItem>
      <FeedItemIcon src={ideaCoverImage()} />
      <FeedItemContent>
        <FeedItemMessage>
          <b>
            <UserChip user={item.owner} compact="very" />
          </b>{" "}
          <span>
            commented on{" "}
            <Link to={`/ideas/${item.idea}`}>
              {t("generic.ideaWithArticle")}
            </Link>
            .
          </span>
        </FeedItemMessage>
        {item.comment ? (
          <div style={{ color: "#5d5d5d" }}>
            <FormattedComment noLink>{item.comment}</FormattedComment>
          </div>
        ) : null}
        <FeedItemDate>{formatDateAt(item.createdAt)}</FeedItemDate>
      </FeedItemContent>
    </FeedItem>
  );
};

export default IdeaCommentFeedItem;
